;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ValidStationIdResponse } from '@/lib/types/api/responses/v1/station/valid'

async function validateStationId(stationId: string) {
  const route = `/api/v1/station/${stationId}/valid/`

  const response = await fetch(route)
  const json = await response.json() as ValidStationIdResponse
  return json.valid
}

export default validateStationId
